module.exports = function() {
  return new Worker(__webpack_public_path__ + "eee2686b91ff9cb4c0a4.worker.js");
};